import { Box, styled } from '@mui/material';
import pallet from '../../../layouts/pallet';

const DownloadButtonSection = styled(Box)(() => ({
  display: 'flex',
  marginBottom: '8px',
  justifyContent: 'flex-end'
}));

const PageWrapper = styled(Box)(() => ({
  marginTop: 16,
  maxWidth: '95%',
  marginLeft: 'auto',
  marginRight: 'auto',
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 16,
  paddingBottom: 16,
  backgroundColor: pallet.N0,
  borderRadius: 8,
  boxShadow: `0px 3px 8px 0px ${pallet.boxShadow}`,
  display: 'flex',
  flexDirection: 'row',
  gap: 16,
  minHeight: 'auto',
  boxSizing: 'border-box'
}));

const ActiveContainer = styled(Box)<{
  backgroundColor?: string;
  color?: string;
}>(({ backgroundColor, color }) => ({
  backgroundColor: backgroundColor || pallet.lightGreen,
  color: color || pallet.green2,
  paddingInline: 12,
  paddingBlock: 4,
  borderRadius: 6,
  fontWeight: 500,
  fontSize: 14,
  height: 'max-content',
  width: 'fit-content'
}));

export { DownloadButtonSection, PageWrapper, ActiveContainer };
